export default __webpack_public_path__ + "img/map-marker-pediatric-active.6b25e17a.png";